import * as ReactDom from 'react-dom';
import { useEffect, useState } from 'react';
import * as React from 'react';


// import { graph } from '@pnp/graph';
// import { MSGraphClient } from '@microsoft/sp-http';
// import { WebPartContext } from "@microsoft/sp-webpart-base";

import { useErrorBoundary } from "use-error-boundary";
import log from 'loglevel';

import { escape } from '@microsoft/sp-lodash-subset';
import * as Fabric from 'office-ui-fabric-react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

import { Channel } from './Channel';
import  * as uuidv4 from "uuid/v4";
import { getAuthenticatedClient } from "../../auth/authClient";

var graph = require('@microsoft/microsoft-graph-client');

export  function ChannelsContainer({ teamId,  accessToken }) {
       
  const [channelsList, setChannelsList] = useState(null);
  const { ErrorBoundary, didCatch, error, errorInfo } = useErrorBoundary();

  log.info(` @ChannelsContainer`);
  log.debug(`@ChannelsContainer accessToken: ${accessToken}`);

  React.useEffect(() => {
        getChannels(teamId,accessToken).then((teamChannels) =>{
        }); 
  }, [accessToken]);

  

  const getChannels = async (teamId, accessToken) =>{
    log.debug(`getChannels @ChannelsContainer - accessToken: ${accessToken}`);
    try {
      
    const channelsUrl = `/teams/${teamId}/channels`; 
    const client = getAuthenticatedClient(accessToken);

    const res = await client
            .api(channelsUrl)
            .headers({
              "Content-Type" : "application/json;charset=UTF-8",
               "mode": "cors",
              "Access-Control-Allow-Origin" : '' 
            })
            .version('beta')
            .get().then((response) => {

                const  selectedChannels =   response.value.map(teamChannel => {
                  const _teamChannel = 
                    {
                        id :  teamChannel.id,
                        webUrl : teamChannel.webUrl,
                        displayName : teamChannel.displayName
                    };
                    
                    return _teamChannel;
                });
                setChannelsList(selectedChannels); 
              }
            );
    } catch (error) {
        log.error(`Error getChannels @ChannelsContainer: ${JSON.stringify()}`);
    } finally {
        log.info(`finally getChannels @ChannelsContainer`);
    }
}

  const MyErrorComponent = ({error})=>{
    log.error(`error ${error.message}`);
    return (
    <div >error</div>
    )
  }

/**
 * handleRenderChannels
 * 
 */
  const renderChannels = ()=>{

    log.info(`renderChannels @ChannelsContainer`)
    if (channelsList == null || channelsList == undefined ){
      return (
        <>  
        <Spinner key={uuidv4()} size={SpinnerSize.large} />
        </> 
      )
    }

    
    let _channelsList = [];
    _channelsList = channelsList.map(channel => {      
              return(
                <ErrorBoundary  key={uuidv4()}
                render={() => 
                            <Channel
                            key={uuidv4()}
                              teamId = {teamId}
                              channelId = {channel.id}
                              channel = {channel}
                              accessToken = { accessToken }
                            />
                        }
                renderError={({ error, errorInfo }) => <MyErrorComponent key={uuidv4()} error={error} />}             
                >
                </ErrorBoundary>              
                        
              ) ;             
            }
          )      
    return _channelsList;
  };
  return (
    <>     
        {renderChannels()}
    </>
  );
}


/**
 * 
 * 
 *      <ul>
        {channelsList.map(channel => {
          return (
              <li key={create_UUID()}>
                <a  key={create_UUID()} href={channel.webUrl}>{channel.displayName}</a>
              </li>
          );
        })}
      </ul>
 
 * 
 * 
 */
/*

 <Channel
                key={create_UUID()}
                teamId = {teamID}
                channelId = {channel.id}
                channelDisplayName = {channel.displayName}
                context = {context}
              ></Channel>

*/ 